import { gql } from '@apollo/client';

export const ACCEPT_TERMS = gql`
  mutation acceptTerms($termsId: UxId!, $acceptedMethod: String!) {
    acceptTerms(termsId: $termsId, acceptedMethod: $acceptedMethod)
  }
`;

export const REQUEST_LOGO_UPLOAD = gql`
  mutation requestLogoUpload($contentType: String!, $extension: String!) {
    requestLogoUpload(contentType: $contentType, extension: $extension) {
      uploadUrl
      key
      publicUrl
    }
  }
`;

export const DEFER_TERMS = gql`
  mutation deferTerms($termsId: UxId!) {
    deferTerms(termsId: $termsId)
  }
`;

export const SET_ACTIVE_WORKSPACE = gql`
  mutation setActiveWorkspace($workspaceId: UxId!) {
    setActiveWorkspace(workspaceId: $workspaceId) {
      activeWorkspace {
        id
      }
    }
  }
`;

export const CANCEL_INVITE = gql`
  mutation cancelInvite($inviteId: UxId!) {
    cancelInvite(inviteId: $inviteId)
  }
`;

export const ACCEPT_INVITE = gql`
  mutation acceptInvite($inviteId: UxId!) {
    acceptInvite(inviteId: $inviteId)
  }
`;

export const REJECT_INVITE = gql`
  mutation rejectInvite($inviteId: UxId!) {
    rejectInvite(inviteId: $inviteId)
  }
`;

export const GRANT_ADMIN = gql`
  mutation grantAdmin($workspaceId: UxId, $organisationId: UxId, $userId: Int!) {
    grantAdmin(workspaceId: $workspaceId, organisationId: $organisationId, userId: $userId)
  }
`;

export const REMOVE_USER = gql`
  mutation removeUser($workspaceId: UxId, $organisationId: UxId, $userId: Int!) {
    removeUser(workspaceId: $workspaceId, organisationId: $organisationId, userId: $userId)
  }
`;

export const REMOVE_PEOPLE = gql`
  mutation removePeople($id: String!) {
    removePeople(id: $id)
  }
`;

export const CANCEL_REQUEST = gql`
  mutation cancelRequest($requestId: UxId, $organisationId: UxId, $workspaceId: UxId) {
    cancelRequest(requestId: $requestId, organisationId: $organisationId, workspaceId: $workspaceId)
  }
`;

export const ACCEPT_REQUEST = gql`
  mutation acceptRequest($requestId: UxId!) {
    acceptRequest(requestId: $requestId)
  }
`;

export const REQUEST_ACCESS = gql`
  mutation requestAccess($workspaceId: UxId, $organisationId: UxId) {
    requestAccess(workspaceId: $workspaceId, organisationId: $organisationId)
  }
`;

export const REJECT_REQUEST = gql`
  mutation rejectRequest($requestId: UxId!) {
    rejectRequest(requestId: $requestId)
  }
`;

export const INVITE_USERS = gql`
  mutation inviteUsers($workspaceId: UxId, $organisationId: UxId, $invitesData: [InviteInput!]!) {
    inviteUsers(workspaceId: $workspaceId, organisationId: $organisationId, invitesData: $invitesData)
  }
`;

export const UPSERT_WORKSPACE = gql`
  mutation upsertWorkspace(
    $workspaceId: UxId
    $organisationId: UxId
    $name: String!
    $primaryContact: String!
    $plan: String
    $isRestricted: Boolean!
    $currency: String
    $notificationScheduleTime: String
    $reviewCadenceDays: Int
    $planType: PlanType
  ) {
    upsertWorkspace(
      workspaceId: $workspaceId
      organisationId: $organisationId
      name: $name
      primaryContact: $primaryContact
      plan: $plan
      isRestricted: $isRestricted
      currency: $currency
      notificationScheduleTime: $notificationScheduleTime
      reviewCadenceDays: $reviewCadenceDays
      planType: $planType
    ) {
      id
    }
  }
`;

export const UPSERT_ORGANISATION = gql`
  mutation upsertOrganisation(
    $organisationId: UxId
    $name: String
    $domain: String
    $primaryContact: String
    $billingContact: String
    $logoKey: String
    $primaryColor: String
    $secondaryColor: String
    $businessType: BusinessType
    $organisationType: OrganisationType
    $parentId: UxId
    $createWorkspace: Boolean
    $workspace: WorkspaceCreateInput
  ) {
    upsertOrganisation(
      organisationId: $organisationId
      name: $name
      domain: $domain
      primaryContact: $primaryContact
      billingContact: $billingContact
      logoKey: $logoKey
      primaryColor: $primaryColor
      secondaryColor: $secondaryColor
      businessType: $businessType
      organisationType: $organisationType
      parentId: $parentId
      createWorkspace: $createWorkspace
      workspace: $workspace
    ) {
      id
    }
  }
`;

export const UPSERT_WORKSPACE_VARIABLES = gql`
  mutation upsertWorkspaceVariables($workspaceId: UxId!, $variables: [VariableInput!]!) {
    upsertWorkspaceVariables(workspaceId: $workspaceId, variables: $variables) {
      id
    }
  }
`;

export const UPSERT_WORKSPACE_QUESTIONS = gql`
  mutation upsertWorkspaceQuestions($workspaceId: UxId!, $questions: QuestionsInput!) {
    upsertWorkspaceQuestions(workspaceId: $workspaceId, questions: $questions) {
      id
    }
  }
`;

export const UPDATE_USER = gql`
  mutation updateUser($orgUnitId: UxId, $userId: Int!, $name: String!, $receiveNotifications: Boolean!, $role: Role) {
    updateUser(
      orgUnitId: $orgUnitId
      userId: $userId
      name: $name
      receiveNotifications: $receiveNotifications
      role: $role
    )
  }
`;

export const ARCHIVE_WORKSPACE = gql`
  mutation archiveWorkspace($id: UxId!) {
    archiveWorkspace(id: $id)
  }
`;

export const UNARCHIVE_WORKSPACE = gql`
  mutation unarchiveWorkspace($id: UxId!) {
    unarchiveWorkspace(id: $id)
  }
`;

export const ARCHIVE_ORGANISATION = gql`
  mutation archiveOrganisation($id: UxId!) {
    archiveOrganisation(id: $id)
  }
`;

export const DELETE_WORKSPACE = gql`
  mutation deleteWorkspace($id: UxId!) {
    deleteWorkspace(id: $id)
  }
`;
